import { T } from "../lib/theme";

const Badge = ({ label, color = "emerald" }) => {
  const map = {
    emerald: { bg: T.onlineDim,  text: T.online  },  // green for "connected"
    sky:     { bg: T.skyDim,     text: T.sky     },
    amber:   { bg: T.amberDim,   text: T.amber   },
    rose:    { bg: T.roseDim,    text: T.rose    },
    violet:  { bg: T.violetDim,  text: T.violet  },
    indigo:  { bg: T.indigoDim,  text: T.indigo  },
  };
  const c = map[color] || map.emerald;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      padding: "3px 10px", borderRadius: 20,
      background: c.bg, color: c.text,
      fontSize: 11, fontWeight: 600, letterSpacing: "0.04em",
    }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: c.text, flexShrink: 0 }} />
      {label}
    </span>
  );
};

export default Badge;
